// extracted by mini-css-extract-plugin
export var active = "Cookies-module--active--3f975";
export var agree = "Cookies-module--agree--cfbb7";
export var cookieBtn = "Cookies-module--cookie-btn--62900";
export var cookieButtons = "Cookies-module--cookie-buttons--c5478";
export var cookieDescription = "Cookies-module--cookie-description--9c3b3";
export var cookieIcon = "Cookies-module--cookie-icon--44905";
export var cookies = "Cookies-module--cookies--91439";
export var privacy = "Cookies-module--privacy--0860b";